export default "__VITE_ASSET__CZSivhu0__"